import React from 'react'

import { Outlet } from 'react-router-dom'

const PublicRoutes = (props) => {
    return <Outlet />
}


export default PublicRoutes;;